/**
 * Papéis usados para autorização na interface.
 *
 * Espelha `core/auth/principal.py::Role`. A interface só esconde o que o
 * usuário não pode fazer — quem autoriza de verdade é a API.
 */
export const Role = {
  STUDENT: 'student',
  INSTRUCTOR: 'instructor',
  TENANT_ADMIN: 'tenant_admin',
  PLATFORM_ADMIN: 'platform_admin',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export function hasRole(roles: readonly string[], ...required: Role[]): boolean {
  return required.some((r) => roles.includes(r));
}

/** Instrutor ou administrador: edita o catálogo e gerencia matrículas. */
export function isAuthor(roles: readonly string[]): boolean {
  return hasRole(roles, Role.INSTRUCTOR, Role.TENANT_ADMIN, Role.PLATFORM_ADMIN);
}

export function isAdmin(roles: readonly string[]): boolean {
  return hasRole(roles, Role.TENANT_ADMIN, Role.PLATFORM_ADMIN);
}

export const ROLE_LABELS: Record<string, string> = {
  [Role.STUDENT]: 'Aluno',
  [Role.INSTRUCTOR]: 'Instrutor',
  [Role.TENANT_ADMIN]: 'Administrador',
  [Role.PLATFORM_ADMIN]: 'Admin da plataforma',
};
